'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoopSubscriptionUsps = function LoopSubscriptionUsps(el) {
  var _this = this;

  (0, _classCallCheck3.default)(this, LoopSubscriptionUsps);

  this.observer = new MutationObserver(function (mutations) {
    if (document.querySelector('.loop-widget-sp-selector-wrapper') !== null) {
      var usps = document.querySelector('.loop-widget-sp-selector-wrapper');
      usps.appendChild(el);

      _this.observer.disconnect();
    }
  });

  this.observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};

exports.default = LoopSubscriptionUsps;